import { create } from 'zustand';
import { User } from '../types/user';
import { getCurrentUser } from '../services/auth';

interface AuthState {
  user: User | null;
  setUser: (user: User | null) => void;
  initializeAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  initializeAuth: async () => {
    const user = await getCurrentUser();
    set({ user });
  },
}));